const getGmapMarkerIcon = (marker, stops) => {
    let color = '42c2f5'
    let numberColor = '000000'
    if (marker.stopNumber == 1) {
    color = '009933'
    numberColor = 'ffffff'
    }

    if (marker.stopNumber == stops[stops.length - 1].stopNumber) {
        color = 'ff9933'
        numberColor = '000000'
    }

    return createGmapMarkerIcon(marker.stopNumber, color, numberColor)
}

const createGmapMarkerIcon = (index, color, numberColor) => {
    return `data:image/svg+xml;charset=UTF-8,%3Csvg width="30" height="30" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg"%3E%3Ccircle cx="15" cy="15" r="12" fill="%23${color}" /%3E%3Ctext x="50%" y="50%" text-anchor="middle" fill="%23${numberColor}" font-size="14" dy=".3em"%3E${index}%3C/text%3E%3C/svg%3E`
}

export { getGmapMarkerIcon, createGmapMarkerIcon }